import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function RentalFigures({rentalsData, rentalsLoaded, totalIncome}){
    const colour = () => {
        if(totalIncome > 0){
            return "table-highlight-green-black-text"
        }
        else if(totalIncome < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }


    if(!rentalsLoaded){
        return <LoadingSpinner/>
    }


    return (
        <div>
            <Title>Rentals</Title>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Long Term Income</th>
                                <th>Total Short Term Income</th>
                                <th>Total Income</th>
                            </tr>
                            <tr>
                                <td>{rentalsData.total_long_term_income}</td>
                                <td>{rentalsData.total_short_term_income}</td>
                                <td className={colour()}>{totalIncome}</td>
                            </tr>
                        </thead>
                    </Table>
                </Column>
            </Columns>
        </div>
    );



}